import axios from "axios";
import { handleSessionExpiry } from "./apiClient";

const userActivityAPIClientFactory = () => {
	const domain =
		sessionStorage.getItem("DomainDetails") !== null
			? sessionStorage.getItem("DomainDetails")
			: "";
	// const domain =
	// 	localStorage.getItem("DomainDetails") !== null
	// 		? localStorage.getItem("DomainDetails")
	// 		: "";
	const apiClient = axios.create({
		baseURL: process.env.REACT_APP_GETWAY_NODE_API_BASE_URL,
		timeout: 30000,
		headers: {
			Authorization: `Bearer ${
				localStorage.getItem("userToken") || "no token"
			}`,
			domain: domain,
		},
	});

	apiClient.interceptors.response.use(
		(response) => response,
		(err) => {
			handleSessionExpiry(err);
			return Promise.reject(err);
		},
	);

	return apiClient;
};

export default userActivityAPIClientFactory;
